import StepWrapper from "./StepWrapper";
import { Form } from "react-bootstrap";

const ItemCountStep = ({
  data: propData,
  onSubmit: propOnSubmit,
  totalSteps,
}) => {
  const data = propData?.cod || {};
  const onSubmit = (x) => propOnSubmit({ ...propData, cod: { ...data, ...x } });

  return (
    <StepWrapper
      step={propData.step}
      total={totalSteps}
      onPrev={() => propOnSubmit({ step: propData.step - 1 })}
      onNext={() => propOnSubmit({ step: propData.step + 1 })}
    >
      <Form.Group className="mb-3">
        <Form.Label>Item Delivered (Rate ₹{propData?.agent?.agent?.rates?.delivery})</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter Delivery Count"
          value={data.deliveryCount}
          onChange={(e) => onSubmit({ deliveryCount: e.target.value })}
          step={1}
          required
          min={0}
          autoFocus
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Item Picked Up (Rate ₹{propData?.agent?.agent?.rates?.pickup})</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter Pickup Count"
          value={data.pickupCount}
          onChange={(e) => onSubmit({ pickupCount: e.target.value })}
          step={1}
          required
          min={0}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>FAD (%)</Form.Label>
        <Form.Control
          type="number"
          placeholder="Enter FAD Percentage"
          value={data.fad}
          onChange={(e) => onSubmit({ fad: e.target.value })}
          required
          min={0}
          step="any"
        />
      </Form.Group>
    </StepWrapper>
  );
};

export default ItemCountStep;
